
(function () {
  // CONFIG
  const GRID_SEL = "ul.media-gallery__grid.list-unstyled";
  const THUMB_SEL = ".custom_scroll_barcss_inner";
  const TRACK_SEL = ".custom_scroll_barcss";
  const THROTTLE_MS = 16; // ~60fps

  // state + cleanup
  let grid = null;
  let thumb = null;
  let track = null;
  let running = false;
  let lastTick = 0;
  let resizeObs = null;
  let mutationObs = null;
  const cleanupFns = [];

  function addCleanup(fn) { cleanupFns.push(fn); }
  function teardown() {
    cleanupFns.forEach(fn => { try { fn(); } catch (e) {} });
    cleanupFns.length = 0;
    if (resizeObs) { try { resizeObs.disconnect(); } catch(e) {} resizeObs = null; }
    if (mutationObs) { try { mutationObs.disconnect(); } catch(e) {} mutationObs = null; }
  }

  // select current elements (returns true if all found)
  function selectElements() {
    grid = document.querySelector(GRID_SEL);
    thumb = document.querySelector(THUMB_SEL);
    track = document.querySelector(TRACK_SEL);
    return !!(grid && thumb && track);
  }

  // compute & set thumb transform
  function updateThumbImmediate() {
    if (!selectElements()) return;

    const now = Date.now();
    if (now - lastTick < THROTTLE_MS) return;
    lastTick = now;

    const pageY = window.scrollY || window.pageYOffset || 0;
    const gridRect = grid.getBoundingClientRect();
    const gridTop = gridRect.top + pageY;
    // when gallery replaced, scrollHeight might reflect new content
    const gridHeight = Math.max(grid.scrollHeight, gridRect.height);
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    const maxGalleryScroll = Math.max(0, gridHeight - viewportHeight);
    if (maxGalleryScroll <= 0) {
      thumb.style.transform = "translateY(0px)";
      return;
    }

    let insideScroll = pageY - gridTop;
    insideScroll = Math.max(0, Math.min(insideScroll, maxGalleryScroll));

    const scrollPercent = insideScroll / maxGalleryScroll;

    const trackHeight = track.offsetHeight;
    const thumbHeight = thumb.offsetHeight;
    const maxThumbMove = Math.max(0, trackHeight - thumbHeight);

    const move = Math.round(scrollPercent * maxThumbMove);
    thumb.style.transform = `translateY(${move}px)`;
  }

  // throttled via rAF
  function updateThumb() {
    if (running) return;
    running = true;
    requestAnimationFrame(() => {
      updateThumbImmediate();
      running = false;
    });
  }

  // initialize handlers and observers
  function init() {
    teardown(); // remove previous listeners/observers

    // try to select elements now
    if (!selectElements()) {
      // if elements not present yet, observe body for them to appear
      observeForElements();
      return;
    }

    // initial update
    updateThumbImmediate();

    // scroll listener
    const onScroll = () => updateThumb();
    window.addEventListener("scroll", onScroll, { passive: true });
    addCleanup(() => window.removeEventListener("scroll", onScroll, { passive: true }));

    // wheel (some themes change on wheel)
    const onWheel = () => updateThumbImmediate();
    window.addEventListener("wheel", onWheel, { passive: true });
    addCleanup(() => window.removeEventListener("wheel", onWheel, { passive: true }));

    // resize listener
    const onResize = () => updateThumb();
    window.addEventListener("resize", onResize, { passive: true });
    addCleanup(() => window.removeEventListener("resize", onResize, { passive: true }));

    // ResizeObserver to catch thumb/track/grid size changes
    if (window.ResizeObserver) {
      try {
        resizeObs = new ResizeObserver(() => updateThumb());
        resizeObs.observe(grid);
        resizeObs.observe(track);
        resizeObs.observe(thumb);
        addCleanup(() => resizeObs.disconnect());
      } catch (e) { /* ignore */ }
    }

    // MutationObserver: watch the grid container's parent (or main) for replacements
    const observeRoot = document.querySelector("body.template_index main#MainContent") || document.body;
    if (window.MutationObserver) {
      mutationObs = new MutationObserver((mutations) => {
        let foundRelevant = false;
        for (const m of mutations) {
          // if new nodes added or nodes removed, check if our selectors are affected
          if (m.addedNodes && m.addedNodes.length) {
            for (const node of m.addedNodes) {
              if (!(node instanceof Element)) continue;
              if (node.matches && (node.matches(GRID_SEL) || node.matches(THUMB_SEL) || node.matches(TRACK_SEL))) {
                foundRelevant = true; break;
              }
              if (node.querySelector && (node.querySelector(GRID_SEL) || node.querySelector(THUMB_SEL) || node.querySelector(TRACK_SEL))) {
                foundRelevant = true; break;
              }
            }
          }
          if (m.removedNodes && m.removedNodes.length) {
            for (const node of m.removedNodes) {
              if (!(node instanceof Element)) continue;
              if (node.matches && (node.matches(GRID_SEL) || node.matches(THUMB_SEL) || node.matches(TRACK_SEL))) {
                foundRelevant = true; break;
              }
            }
          }
          if (foundRelevant) break;
        }
        if (foundRelevant) {
          // small debounce for DOM stability
          setTimeout(init, 40);
        }
      });

      mutationObs.observe(observeRoot, { childList: true, subtree: true });
      addCleanup(() => mutationObs.disconnect());
    }

    // React to known theme events (Atelier / Shopify)
    const shopifyEvents = ["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"];
    shopifyEvents.forEach(ev => {
      const h = () => setTimeout(init, 40);
      document.addEventListener(ev, h);
      addCleanup(() => document.removeEventListener(ev, h));
    });

    // Variant/product events (many themes fire these on variant change)
    const variantEvents = ["variant:change", "variant:updated", "product:variant:change", "shopify:section:select"];
    variantEvents.forEach(ev => {
      const h = () => setTimeout(init, 30);
      document.addEventListener(ev, h);
      addCleanup(() => document.removeEventListener(ev, h));
    });

    // expose manual updater
    window.__atelier_update_thumb = updateThumbImmediate;
  }

  // If elements not present yet, watch for them to appear, then init
  function observeForElements() {
    if (!window.MutationObserver) return;
    const root = document.body;
    const mo = new MutationObserver((mutations) => {
      if (selectElements()) {
        mo.disconnect();
        init();
      }
    });
    mo.observe(root, { childList: true, subtree: true });
    addCleanup(() => mo.disconnect());
  }

  // bootstrap on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // ensure cleanup on page unload (rare)
  window.addEventListener("beforeunload", () => teardown());

  // expose cleanup if needed
  window.__atelier_thumb_cleanup = teardown;
})();












document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("slideshow-slides");

  if (!slider) return;

  // Create scrollbar wrapper
  const bar = document.createElement("div");
  bar.className = "mobile-scrollbar";

  // Create thumb
  const thumb = document.createElement("div");
  thumb.className = "mobile-scrollbar-thumb";

  // Append thumb inside bar
  bar.appendChild(thumb);

  // Insert scrollbar after slider
  slider.parentNode.insertBefore(bar, slider.nextSibling);

  function updateThumbWidth() {
    const ratio = slider.clientWidth / slider.scrollWidth;
    thumb.style.width = `${ratio * 100}%`;
  }

  function updateThumbPosition() {
    const scrollLeft = slider.scrollLeft;
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (maxScroll <= 0) return;

    const percent = scrollLeft / maxScroll;

    const trackWidth = bar.clientWidth;
    const thumbWidth = thumb.clientWidth;
    const maxMove = trackWidth - thumbWidth;

    thumb.style.transform = `translateX(${percent * maxMove}px)`;
  }

  updateThumbWidth();
  updateThumbPosition();

  slider.addEventListener("scroll", updateThumbPosition);
  window.addEventListener("resize", () => {
    updateThumbWidth();
    updateThumbPosition();
  });
});































document.addEventListener("DOMContentLoaded", function () {

  const main = document.querySelector("body.template_index main#MainContent");
  const footer = document.querySelector("footer");

  if (!main || !footer) return;

  // Collect footer + all sections after footer
  const elements = [];

  let current = footer;
  while (current) {
    if (
      current.matches("footer") ||
      current.matches(".shopify-section")
    ) {
      elements.push(current);
    }
    current = current.nextElementSibling;
  }

  if (!elements.length) return;

  // Create wrapper
  const wrapper = document.createElement("div");
  wrapper.classList.add("shopify-section", "custom_footer_main");

  // Append elements to wrapper
  elements.forEach(el => wrapper.appendChild(el));

  // Insert wrapper inside MainContent at the end
  main.appendChild(wrapper);



/* Homepage full-screen "section scrolling" (fullpage stack + page notation).
   Disabled Sep 21 2026 per request: turn off section scrolling on homepage (mobile + desktop). */
const ENABLE_HOMEPAGE_SECTION_SCROLLING = false;
if (ENABLE_HOMEPAGE_SECTION_SCROLLING) {
  /* notation js  */
  const mainContent = document.querySelector('body.template_index main#MainContent');
  if (mainContent) {
    const notationDiv = document.createElement('div');
    notationDiv.id = 'fp-notation';
    notationDiv.innerHTML = `
      <span id="fp-current"></span>/<span id="fp-total"></span>
      <div class="fp-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 14.707 14.707" xml:space="preserve"><g><rect x="6.275" y="0" style="fill:currentcolor;" width="0.0001" height="14.707"/></g></svg></div>`;
    mainContent.insertAdjacentElement('afterend', notationDiv);
  }


  (function () {
    // CONFIG
    const selector = 'body.template_index main#MainContent>.shopify-section';
    const TRANSITION_MS = 700;
    const SWIPE_THRESHOLD = 50;
    const preventNativeScroll = true;

    // Mobile detection
    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

  

    // Minimal CSS
    const style = document.createElement('style');
    style.innerHTML = `
    .__fp_section_injected {
      position: fixed !important;
      left: 0 !important;
      top: 0 !important;
      width: 100% !important;
      height: 100vh !important;
      margin: 0 !important;
      box-sizing: border-box !important;
      will-change: transform;
      transition: transform ${TRANSITION_MS}ms cubic-bezier(.2,.8,.2,1) !important;
      pointer-events: none;
      z-index: 1 !important;
    }
    .__fp_section_injected.__fp_active { pointer-events: auto; }
    `;
    document.head.appendChild(style);

    const nodeList = document.querySelectorAll(selector);
    if (!nodeList.length) return;

    const sections = Array.from(nodeList);

    let index = 0;
    let animating = false;

    // Build actual flow based on device

  function getFlow() {
    const flow = [];

    sections.forEach((el, i) => {
      const hasMobileOnly = el.querySelector('.mobile_only_hk');
      const hasDesktopOnly = el.querySelector('.desktop_only_hk');

      if (isMobile()) {
        // On mobile → exclude desktop-only sections
        if (hasDesktopOnly) return;
      } else {
        // On desktop → exclude mobile-only sections
        if (hasMobileOnly) return;
      }

      flow.push(i);
    });

    return flow;
  }

  function getMaxFlowIndex() {
    return getFlow().length - 1;
  }
    // Prepare sections
    sections.forEach((el, i) => {
      el.classList.add('__fp_section_injected');
      el.setAttribute('data-fp-index', i);
      el.style.overflow = 'hidden';
      el.style.zIndex = 100 + i;
      el.style.transform = `translateY(${(i - index) * 100}vh)`;
    });

    // ---- Zone detection (scroll only inside sections) ----
    function isInsideFPZone(e) {
      for (const sec of sections) {
        if (sec.contains(e.target)) return true;
      }
      return false;
    }

    // Update notation
  function updateNotation() {
    const flow = getFlow();
    const total = flow.length;

    const curEl = document.querySelector('#fp-current');
    const totalEl = document.querySelector('#fp-total');
    const arrowEl = document.querySelector('#fp-notation .fp-arrow');
    const notationContainer = document.querySelector('#fp-notation');

    if (!notationContainer || !curEl || !totalEl || !arrowEl) return;

    // If only 1 section → hide
    if (total <= 1) {
      notationContainer.style.display = 'none';
      return;
    }

    // Hide on first and last section
    if (index === 0 || index === total - 1) {
      notationContainer.style.display = 'none';
      return;
    }

    notationContainer.style.display = 'block';

    // Human-readable numbering (1-based)
    curEl.textContent = String(index + 1);
    totalEl.textContent = String(total);
  }

    function updateTransforms(withTransition = true) {
      const flow = getFlow();
      const activeRealIndex = flow[index];

      sections.forEach((el, realIndex) => {
        const flowPos = flow.indexOf(realIndex);
        let offset = flowPos === -1 ? 200 : (flowPos - index) * 100;

        el.style.transition = withTransition
          ? `transform ${TRANSITION_MS}ms cubic-bezier(.2,.8,.2,1)`
          : "none";
        el.style.transform = `translateY(${offset}vh)`;

        if (realIndex === activeRealIndex) el.classList.add('__fp_active');
        else el.classList.remove('__fp_active');
      });
    }

  function goTo(flowIndexTarget) {
    if (animating) return;

    const max = getMaxFlowIndex();

    // Proper clamping
    if (flowIndexTarget > max) flowIndexTarget = max;
    if (flowIndexTarget < 0) flowIndexTarget = 0;

    if (flowIndexTarget === index) return;

    animating = true;
    index = flowIndexTarget;

    updateTransforms(true);
    updateNotation();

    setTimeout(() => {
      animating = false;
    }, TRANSITION_MS + 30);
  }

    // Initial snap
    setTimeout(() => {
      updateTransforms(false);
      updateNotation();
      setTimeout(() => updateTransforms(true), 20);
    }, 50);

    // ---- Gestures ----
    const GESTURE_PAUSE_MS = 350;
    let gestureActive = false, gestureTimer = null;
    function armGesturePause() {
      if (gestureTimer) clearTimeout(gestureTimer);
      gestureTimer = setTimeout(() => {
        gestureActive = false;
        gestureTimer = null;
      }, GESTURE_PAUSE_MS);
    }

    // ----- Wheel handler -----
    let inWheelGesture = false, wheelEndTimer = null;
    const WHEEL_GESTURE_PAUSE = 350;

    function onWheelGestureEnd() {
      inWheelGesture = false;
      if (wheelEndTimer) { clearTimeout(wheelEndTimer); wheelEndTimer = null; }
    }

    window.addEventListener('wheel', function (e) {
      if (!preventNativeScroll) return;
      if (!isInsideFPZone(e)) return;   // <-- ONLY inside zone
      e.preventDefault();
      if (animating) {
        if (wheelEndTimer) clearTimeout(wheelEndTimer);
        wheelEndTimer = setTimeout(onWheelGestureEnd, WHEEL_GESTURE_PAUSE);
        return;
      }
      if (inWheelGesture) {
        if (wheelEndTimer) clearTimeout(wheelEndTimer);
        wheelEndTimer = setTimeout(onWheelGestureEnd, WHEEL_GESTURE_PAUSE);
        return;
      }
      inWheelGesture = true;

      if (e.deltaY > 0) goTo(index + 1);
      else if (e.deltaY < 0) goTo(index - 1);

      if (wheelEndTimer) clearTimeout(wheelEndTimer);
      wheelEndTimer = setTimeout(onWheelGestureEnd, WHEEL_GESTURE_PAUSE);
    }, { passive: false, capture: true });

    // ----- Touch handlers -----
    let startY = 0, moved = false;

    window.addEventListener('touchstart', e => {
      if (!isInsideFPZone(e)) return;
      startY = e.touches[0].clientY;
      moved = false;
    }, { passive: true });

    window.addEventListener('touchmove', () => { moved = true; }, { passive: true });

    window.addEventListener('touchend', e => {
      if (!isInsideFPZone(e) || !moved || animating) return;
      const endY = e.changedTouches[0].clientY;
      const diff = startY - endY;
      if (Math.abs(diff) < SWIPE_THRESHOLD) return;
      if (gestureActive) return;
      gestureActive = true;

      if (diff > 0) goTo(index + 1);
      else goTo(index - 1);

      armGesturePause();
    }, { passive: true });

    // Keyboard support (optional)
    window.addEventListener('keydown', e => {
      if (animating) return;
      if (!sections.some(sec => sec.contains(document.activeElement))) return; // only if focus inside
      if (e.key === "ArrowDown" || e.key === "PageDown") { e.preventDefault(); goTo(index + 1); }
      else if (e.key === "ArrowUp" || e.key === "PageUp") { e.preventDefault(); goTo(index - 1); }
    });

    // Resize → re-render
    window.addEventListener('resize', () => {
      updateTransforms(false);
      setTimeout(() => updateTransforms(true), 50);
    });

    // Expose control API
    window.__fp_stack = {
      goTo,
      next: () => goTo(index + 1),
      prev: () => goTo(index - 1),
      getIndex: () => index,
      getFlow
    };

  })();
}




});






/* Dynamic mobile horizontal scrollbar for <slideshow-slides> (no HTML edits) */
(function () {
  const SLIDER_SELECTOR = ".product-card__content .card-gallery slideshow-component slideshow-slides, .template_product media-gallery slideshow-slides";
  const MOBILE_MAX = 915; // show only on <= this width
  const STYLE_ID = "auto-mobile-scrollbar-styles";

  // Insert CSS once
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: ${MOBILE_MAX}px) {
        .mobile-scrollbar {
          width: 100%;
          height: 1px;
          background: rgb(218, 218, 218);
          margin-top: 0px;
          border-radius: 4px;
          position: relative;
          overflow: hidden;
        }
        .mobile-scrollbar-thumb {
          height: 100%;
          background: #000;
          border-radius: 4px;
          transform: translateX(0);
          will-change: transform;
        }
        /* hide native scrollbar for the slider if desired */
        ${SLIDER_SELECTOR} { scrollbar-width: none; -ms-overflow-style: none; }
        ${SLIDER_SELECTOR}::-webkit-scrollbar { height: 0; }
      }
      @media (min-width: ${MOBILE_MAX + 1}px) {
        .mobile-scrollbar { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  // Helper: create bar+thumb
  function createBar() {
    const bar = document.createElement("div");
    bar.className = "mobile-scrollbar";
    const thumb = document.createElement("div");
    thumb.className = "mobile-scrollbar-thumb";
    bar.appendChild(thumb);
    return { bar, thumb };
  }

  // Init for a single slider element
  function initForSlider(slider) {
    if (!slider || slider.__mobileScrollbarInitialized) return;
    slider.__mobileScrollbarInitialized = true;

    // Make sure we only create one bar for this slider
    // prefer to insert after slider in DOM
    const { bar, thumb } = createBar();
    try {
      slider.parentNode.insertBefore(bar, slider.nextSibling);
    } catch (e) {
      // fallback: append to body
      document.body.appendChild(bar);
    }

    // Update thumb width and pos
    function updateThumbSize() {
      // hide on desktop
      if (window.innerWidth > MOBILE_MAX) {
        bar.style.display = "none";
        return;
      } else {
        bar.style.display = "";
      }

      const scrollW = slider.scrollWidth || 0;
      const clientW = slider.clientWidth || 1;
      const ratio = Math.min(1, clientW / Math.max(scrollW, 1));
      const thumbWidthPx = Math.max(6, Math.floor(ratio * bar.clientWidth));
      thumb.style.width = thumbWidthPx + "px";
      updateThumbPos();
    }

    function updateThumbPos() {
      const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      if (maxScroll <= 0) {
        thumb.style.transform = "translateX(0px)";
        return;
      }
      const percent = slider.scrollLeft / maxScroll;
      const maxMove = Math.max(0, bar.clientWidth - thumb.clientWidth);
      const x = Math.round(percent * maxMove);
      thumb.style.transform = `translateX(${x}px)`;
    }

    // listeners
    const onScroll = () => updateThumbPos();
    const onResize = () => updateThumbSize();

    slider.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });

    // If images inside slider load later, update sizes
    let imgObserver;
    if (window.MutationObserver) {
      imgObserver = new MutationObserver((mutations) => {
        // if images added / removed, recalc
        updateThumbSize();
      });
      imgObserver.observe(slider, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "srcset"] });
    }

    // ResizeObserver for bar/slider size changes
    let ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(() => updateThumbSize());
      try { ro.observe(slider); ro.observe(bar); } catch (e) {}
    }

    // cleanup reference to allow re-init if slider removed and re-added
    slider.__mobileScrollbarCleanup = function () {
      try { slider.removeEventListener("scroll", onScroll); } catch (e) {}
      try { window.removeEventListener("resize", onResize); } catch (e) {}
      try { imgObserver && imgObserver.disconnect(); } catch (e) {}
      try { ro && ro.disconnect(); } catch (e) {}
      try { if (bar && bar.parentNode) bar.parentNode.removeChild(bar); } catch (e) {}
      slider.__mobileScrollbarInitialized = false;
      slider.__mobileScrollbarCleanup = null;
    };

    // initial calc (ensure DOM paints first)
    setTimeout(() => {
      updateThumbSize();
      updateThumbPos();
    }, 50);

    // Also update when the user touches (for mobile scroll inertia)
    slider.addEventListener("touchmove", updateThumbPos, { passive: true });
    slider.addEventListener("touchend", updateThumbPos, { passive: true });
  }

  // Remove old initializations for sliders that were removed from DOM
  function cleanupRemoved() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(s => {
      // ok
    });
    // find any elements that had __mobileScrollbarInitialized true but are no longer in DOM
    // loop global window properties not ideal; instead track created sliders list
  }

  // Scan existing sliders and init
  function scanAndInit() {
    const sliders = document.querySelectorAll(SLIDER_SELECTOR);
    if (!sliders || sliders.length === 0) return;
    sliders.forEach(s => {
      try { initForSlider(s); } catch (e) {}
    });
  }

  // MutationObserver: watch the document for new sliders (works when theme replaces gallery)
  if (window.MutationObserver) {
    const mo = new MutationObserver((mutations) => {
      let found = false;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (!(n instanceof Element)) continue;
            if (n.matches && n.matches(SLIDER_SELECTOR)) { found = true; break; }
            if (n.querySelector && n.querySelector(SLIDER_SELECTOR)) { found = true; break; }
          }
        }
      }
      if (found) setTimeout(scanAndInit, 40);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // no cleanup (page live)
  }

  // Boot: wait for DOM ready then scan. If DOM already ready, run now.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAndInit);
  } else {
    scanAndInit();
  }

  // also re-scan on window load to catch late-rendered images/content
  window.addEventListener("load", () => setTimeout(scanAndInit, 30));
})();











document.addEventListener('DOMContentLoaded', function() {

  // Select top-level menu links that have a submenu
  const menuLinks = document.querySelectorAll('a.menu-list__link');

  menuLinks.forEach(link => {
    const submenu = link.nextElementSibling;
    if (submenu && submenu.classList.contains('menu-list__submenu')) {

      // Hover event
      link.addEventListener('mouseenter', () => {
        const slider = submenu.querySelector('.mega-menu-product-slider');
        if(slider && $(slider).hasClass('slick-initialized')) {
          $(slider).slick('refresh');
        } else {
          $(slider).slick('refresh');
        }
        const slider2 = submenu.querySelector('.mega-menu-product-slider3');
        if(slider2 && $(slider2).hasClass('slick-initialized')) {
          $(slider2).slick('refresh');
        } else {
          $(slider2).slick('refresh');
        }
      });
      link.addEventListener('mouseleave', () => {
        const slider = submenu.querySelector('.mega-menu-product-slider');
        if(slider && $(slider).hasClass('slick-initialized')) {
          $(slider).slick('refresh');
        } else {
          $(slider).slick('refresh');
        }
        const slider2 = submenu.querySelector('.mega-menu-product-slider3');
        if(slider2 && $(slider2).hasClass('slick-initialized')) {
          $(slider2).slick('refresh');
        } else {
          $(slider2).slick('refresh');
        }
      });

      // Click event (for mobile)
      link.addEventListener('click', () => {
        const slider = submenu.querySelector('.mega-menu-product-slider');
        if(slider && $(slider).hasClass('slick-initialized')) {
          $(slider).slick('refresh');
        }else {
          $(slider).slick('refresh');
        }
        const slider2 = submenu.querySelector('.mega-menu-product-slider3');
        if(slider2 && $(slider2).hasClass('slick-initialized')) {
          $(slider2).slick('refresh');
        }else {
          $(slider2).slick('refresh');
        }
      });

    }
  });

});


document.addEventListener('DOMContentLoaded', function() {

  const drawerButton = document.querySelector('summary#HeaderDrawer-women');

  if(drawerButton) {
    drawerButton.addEventListener('click', function() {
      // Delay slightly to allow drawer to open & DOM to render
      setTimeout(() => {
          $('.mega-menu-product-slider2').slick('refresh');
      }, 100); // adjust delay if needed
    });
  }
  const drawerButton2 = document.querySelector('summary#HeaderDrawer-men');

  if(drawerButton2) {
    drawerButton2.addEventListener('click', function() {
      // Delay slightly to allow drawer to open & DOM to render
      setTimeout(() => {
          $('.mega-menu-product-slider4').slick('refresh');
      }, 100); // adjust delay if needed
    });
  }

});


$(document).on("click", "#BIS_trigger", function () {
  $("#klaviyo-bis-iframe").hide();

  setTimeout(function () {
    $("#klaviyo-bis-iframe").show();
  }, 500);
});

function scrollWithOffset(selector, offset = 100) {
  const target = document.querySelector(selector);
  if (!target) return;

  const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}

$(document).on("click", ".product-information__grid .shopify-app-block.jdgm-horizon-widget", function (e) {
  e.preventDefault();
  scrollWithOffset('.main_pdp_reviews', 60);
});

$(document).on("click", ".product-information__grid accordion-custom:nth-child(1)", function (e) {
  e.preventDefault();
  scrollWithOffset('.product_details_main', 60);
});



document.addEventListener('variant:change', function(event) {
  if (!event.detail.variant) return;

  const priceContainer = document.querySelector('[data-product-price]');
  if (!priceContainer) return;

  const newPrice = Shopify.formatMoney(
    event.detail.variant.price,
    "{{ shop.money_format }}"
  );

  priceContainer.innerHTML = newPrice;
});



$(document).ready(function () {

  // Check if slideshow exists
  var $slideshow = $('.product-information__grid slideshow-component');

  if ($slideshow.length === 0) return; // Exit if not present

  // Bind keyboard only if exists
  $(document).on('keydown.productSlideshow', function (e) {

    // Prevent triggering while typing
    if ($(e.target).is('input, textarea, select')) return;

    if (e.key === 'ArrowRight') {
      var $nextBtn = $slideshow.find('.slideshow-control--next');
      if ($nextBtn.length) {
        e.preventDefault();
        $nextBtn.trigger('click');
      }
    }

    if (e.key === 'ArrowLeft') {
      var $prevBtn = $slideshow.find('.slideshow-control--previous');
      if ($prevBtn.length) {
        e.preventDefault();
        $prevBtn.trigger('click');
      }
    }

  });


  


});
















function updateMediaCounter() {
  var $slides = $('.product-information__grid slideshow-slide');

  if (!$slides.length) return;

  var activeIndex = 1;

  $slides.each(function(index) {
    if ($(this).attr('aria-hidden') === 'false') {
      activeIndex = index + 1;
    }
  });

  $('.custom_counter .current_number').text(activeIndex);
}

// Run on page load
$(document).ready(function() {
  updateMediaCounter();
});

// Listen for aria-hidden changes (important)
var targetNode = document.querySelector('.product-information__grid slideshow-component');

if (targetNode) {
  var observer = new MutationObserver(function() {
    updateMediaCounter();
  });

  observer.observe(targetNode, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
}


$(document).on('click', '.product_media_main img', function (e) {

  var $img = $(this);
  var $container = $img.closest('.product_media_main');
  var rect = this.getBoundingClientRect();

  if (!$container.hasClass('zoomed')) {

    var offsetX = e.clientX - rect.left;
    var offsetY = e.clientY - rect.top;

    var percentX = (offsetX / rect.width) * 100;
    var percentY = (offsetY / rect.height) * 100;

    $img.css({
      transformOrigin: percentX + '% ' + percentY + '%',
      transform: 'scale(3)'
    });

    $container.addClass('zoomed');

  } else {

    $img.css({
      transform: 'scale(1)',
      transformOrigin: 'center center'
    });

    $container.removeClass('zoomed');
  }

});
